// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 550px) {\n.table-typo td,\n  .table-typo th {\n    display: block;\n    background-color: #fff;\n    border: 1px solid #ddd;\n}\n}\n", ""]);
// Exports
module.exports = exports;
